import * as firebase from 'firebase/app';
import { getAuth } from 'firebase/auth';

import { ENV } from '../env';
import { isZeosEnvironments } from '../services/environment/EnvironmentHelpers';
import { IZeosApiConfig } from '../services/zeos-api/IZeosApiConfig';
import { FirebaseConfig } from './FirebaseConfig';

//AccountAuth references dataConfig. Will cause circular dependency if reference AccountAuth here.
try {
  firebase.initializeApp(FirebaseConfig);
} catch (error) {}
const firebaseAuth = getAuth(firebase.getApp());
const authTokenAsync = async () => {
  const auth = await firebaseAuth.currentUser?.getIdTokenResult();
  return auth?.token;
};

// export const dataConfig = {
//   apiUrl: ENV.VLX_API_URL,
//   apiKey: ENV.VLX_API_KEY,
//   apiVersion: `/v${ENV.VLX_API_VERSION}`,
//   apiAuthToken: authTokenAsync,
//   doEcho: false,
// } as IDataConfig;

export const ZeosApiConfig = {
  apiAuthToken: authTokenAsync,
  apiKey: ENV.ZEOS_API_KEY ?? "",
  apiUrl: ENV.ZEOS_API_URL ?? "",
  apiVersion: ENV.ZEOS_API_VERSION ? `/v${ENV.ZEOS_API_VERSION}` : "",
  doEcho: false && isZeosEnvironments(["local", "dev", "qa"]),
} as IZeosApiConfig;
